import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";
import { ReportBoardResponse } from "../../api/board_report";

export type TApiPutReportBoardResult = {
  result?: ReportBoardResponse;
};

export const putReportBoard = async (
     board_id: number,
     reason: string
): Promise<TApiResult & TApiPutReportBoardResult> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;
  return await client()
    .board.report.put({
      query: {
        board_id,
        reason
      },
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "putReportBoard");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
